import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import axios from "axios";
import Select from "react-select";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { FaEye, FaDownload, FaTrash } from "react-icons/fa";

const Job_card = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { globalValue } = useContext(GlobalContext);
  const [customers, setCustomers] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedServices, setSelectedServices] = useState([]);
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [photos, setPhotos] = useState([]);
  const [jobCards, setJobCards] = useState([]);

  const fetchJobCards = async () => {
    try {
      const response = await axios.get(`${globalValue}/job_card/display`, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"), // Add the token header here
        },
      });

      const jobCardData = response.data.map((card) => ({
        id: card.id,
        customer_id: card.customer_id,
        service_ids: JSON.parse(card.service_ids),
        photos: JSON.parse(card.photos),
        date: card.date,
      }));
      setJobCards(jobCardData);
    } catch (error) {
      console.error("Error fetching job cards:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${globalValue}/customers`, {
          headers: {
            "x-access-token": sessionStorage.getItem("token"), // Add the token header here
          },
          params: {
            data: sessionStorage.getItem("branch"),
            position: "",
          },
        });

        const formattedCustomers = response.data.map((item) => ({
          value: item[1],
          label: item[2],
          v_no: item[4],
        }));
        setCustomers(formattedCustomers);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    const fetchServices = async () => {
      try {
        const response = await axios.get(`${globalValue}/services`, {
          headers: {
            "x-access-token": sessionStorage.getItem("token"), // Add the token header here
          },
          params: {
            data: sessionStorage.getItem("branch"),
            position: "",
          },
        });

        const formattedServices = response.data.map((service) => ({
          value: service[1],
          label: service[2],
        }));
        setServices(formattedServices);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchData();
    fetchServices();
    fetchJobCards();
  }, [globalValue]);

  const openCamera = async () => {
    const video = document.createElement("video");
    const select = document.createElement("select");
    const videoContainer = document.createElement("div");
    videoContainer.style.display = "flex";
    videoContainer.style.flexDirection = "column";
    videoContainer.style.alignItems = "center";
    videoContainer.style.gap = "10px";

    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter(
      (device) => device.kind === "videoinput"
    );

    videoDevices.forEach((device, index) => {
      const option = document.createElement("option");
      option.value = device.deviceId;
      option.textContent = device.label || `Camera ${index + 1}`;
      select.appendChild(option);
    });

    const startCamera = async (deviceId) => {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { exact: "environment" } },
      });
      video.srcObject = stream;
      video.play();
    };

    select.addEventListener("change", async () => {
      const deviceId = select.value;
      const stream = video.srcObject;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      await startCamera(deviceId);
    });

    await startCamera(videoDevices[0].deviceId);

    const capturePhoto = () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const photo = canvas.toDataURL("image/png");
      setPhotos((prev) => [...prev, photo]);
      const stream = video.srcObject;
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
    };

    videoContainer.appendChild(select);
    videoContainer.appendChild(video);

    Swal.fire({
      title: "Capture Photo",
      html: videoContainer,
      showCancelButton: true,
      confirmButtonText: "Capture",
      cancelButtonText: "Cancel",
      preConfirm: capturePhoto,
    });
  };

  const handleImagePicker = (event) => {
    const files = event.target.files;
    if (files) {
      const selectedPhotos = Array.from(files).map((file) =>
        URL.createObjectURL(file)
      );
      setPhotos((prev) => [...prev, ...selectedPhotos]);
    }
  };

  const handleSubmit = async () => {
    if (!selectedCustomer || selectedServices.length === 0) {
      Swal.fire("Error", "Please fill in all required fields!", "error");
      return;
    }

    const formData = new FormData();
    formData.append("customerId", selectedCustomer.value);
    formData.append("date", date);
    formData.append(
      "services",
      JSON.stringify(selectedServices.map((service) => service.value))
    );

    for (const [index, photo] of photos.entries()) {
      const blob = await fetch(photo).then((res) => res.blob());
      formData.append(`photos_${index}`, blob, `photo_${index}.png`);
    }

    try {
      const response = await axios.post(
        `${globalValue}/job_card/submit`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": sessionStorage.getItem("token"), // Add the token header here
          },
        }
      );

      if (response.data === "success") {
        Swal.fire("Success", "Job card submitted successfully!", "success");
        setModalOpen(false);
        fetchJobCards();
      }
    } catch (error) {
      console.error("Error submitting job card:", error);
      Swal.fire("Error", "Failed to submit job card.", "error");
    }
  };
  const customStyles = {
    table: {
      style: {
        backgroundColor: "white",
        width: "100%",
        border: "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor: "rgb(226, 232, 240)",
        color: "black",
        fontWeight: "bold",
      },
    },
  };

  const [img_data, setImg_data] = useState([]);
  const [img_view, setImg_view] = useState(false);
  const [job_card_id, setJob_card_id] = useState("");
  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Customer ID",
      selector: (row) => row.customer_id,
      sortable: true,
    },
    {
      name: "Services",
      selector: (row) => row.service_ids.join(", "),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => {
        const date = new Date(row.date);
        return new Intl.DateTimeFormat("en-GB").format(date);
      },
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => (
        <button
          onClick={() => {
            setImg_data(row.photos);
            setImg_view(true);
            setJob_card_id(row.id);
          }}
          className="text-blue-500"
        >
          <FaEye size={20} />
        </button>
      ),
      button: true,
    },
  ];

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleImageDownload = (imageUrl) => {
    const link = document.createElement("a");

    link.href = `${globalValue}/get_image/${imageUrl}`;

    link.download = `${imageUrl.split("/").pop()}`;

    link.click();
  };

  const handleImageDelete = async (imageUrl, job_card_id) => {
    try {
      const response = await axios.post(
        `${globalValue}/delete_image`,
        {
          imageUrl,
          job_card_id,
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"), // Add the token header here
          },
        }
      );

      if (response.data === "success") {
        setImg_view(false);
        fetchJobCards();
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  return (
    <div>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)]  mt-16 h-[92vh] flex justify-center items-center box-border`}
      >
        <div className="w-[95%] md:w-[98%] h-[95%] bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
          <div className="flex justify-between mb-6">
            <h1 className="text-3xl text-gray-600">Job Card</h1>
            <button
              onClick={() => {
                setModalOpen(true);
                setPhotos([]);
                setSelectedCustomer(null);
                setSelectedServices([]);
              }}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add Job Card
            </button>
          </div>

          <DataTable
            columns={columns}
            data={jobCards}
            customStyles={customStyles}
            pagination
            highlightOnHover
          />
        </div>
      </div>

      <Modal show={img_view} onClose={() => setImg_view(false)}>
        <Modal.Header className="flowbite-modal-h">Image Preview</Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {img_data.map((imageUrl, index) => (
              <div key={index} className="relative w-full">
                <img
                  src={`${globalValue}/get_image/${imageUrl}`}
                  alt={`Preview ${index + 1}`}
                  className="w-full max-h-[300px] object-contain rounded-lg cursor-pointer"
                  onClick={() => handleImageDownload(imageUrl)}
                />
                <div className="absolute top-2 right-2 flex space-x-2">
                  <FaTrash
                    className="text-white bg-red-600 p-1 rounded-full cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleImageDelete(imageUrl, job_card_id);
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>

      {modalOpen && (
        <Modal show={modalOpen} size="lg" onClose={() => setModalOpen(false)}>
          <Modal.Header className="flowbite-modal-h">
            Create Job Card
          </Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="space-y-4">
              <div>
                <Label value="Select Customer" />
                <Select
                  options={customers}
                  onChange={(selected) => setSelectedCustomer(selected)}
                  isSearchable
                  placeholder="Search for a customer..."
                  className="mt-2"
                  getOptionLabel={(option) =>
                    `${option.label} (${option.v_no})`
                  }
                  getOptionValue={(option) => option.value}
                  filterOption={(candidate, input) => {
                    const lowerCaseInput = input.toLowerCase();
                    const lowerCaseLabel = (
                      candidate.label || ""
                    ).toLowerCase();
                    const lowerCaseVNo = (candidate.v_no || "").toLowerCase();

                    return (
                      lowerCaseLabel.includes(lowerCaseInput) ||
                      lowerCaseVNo.includes(lowerCaseInput)
                    );
                  }}
                />
              </div>
              <div>
                <Label value="Select Services" />
                <Select
                  options={services}
                  isMulti
                  onChange={(selected) => setSelectedServices(selected)}
                  placeholder="Select services..."
                />
              </div>
              <div>
                <Label value="Select Date" />
                <TextInput
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  color="white"
                />
              </div>
              <div>
                <Label value="Add Photos" />
                <div className="flex space-x-2">
                  <button
                    onClick={openCamera}
                    className="bg-green-500 text-white px-4 py-2 rounded"
                  >
                    Open Camera
                  </button>
                  <label
                    htmlFor="imagePicker"
                    className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer"
                  >
                    Select Images
                  </label>
                  <input
                    id="imagePicker"
                    type="file"
                    accept="image/*"
                    multiple
                    className="hidden"
                    onChange={(e) => handleImagePicker(e)}
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                  {photos.map((photo, index) => (
                    <div key={index} className="relative">
                      <img
                        src={photo}
                        alt={`Captured ${index + 1}`}
                        className="w-full h-32 object-cover rounded shadow"
                      />
                      <button
                        onClick={() =>
                          setPhotos((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                      >
                        &times;
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <button
              onClick={handleSubmit}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
            <button
              onClick={() => setModalOpen(false)}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded ml-2"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default Job_card;
